module.exports = __webpack_public_path__ + "img/full-moon-chalawan.80d82dbf.png";